export default __webpack_public_path__ + "static/media/services-bg.088b9ddc.png";